<template>
  <div id="home" @touchmove="scrolling()" @wheel="scrolling()">
    <!-- <Tree v-if="$route.query.style == 'myAppTree'"></Tree> -->
    <Navbar
      v-if="$route.query.name || $route.query.logo || $route.query.totalCoins "
      :name="$route.query.name"
      :logoUrl="$route.query.logo"
      :totalCoins="totalCoins"
    />
        
    <b-nav id="tabs" fill v-if="!isMobile()">
      <b-nav-item class="WEB" id="webTab" @click="createPath('WEB',$route.params.country)">WEB</b-nav-item>
      <b-nav-item class="ANDROID" id="androidTab" @click="createPath('ANDROID',$route.params.country)">ANDROID</b-nav-item>
      <b-nav-item class="IOS" id="iosTab" @click="createPath('IOS',$route.params.country)">IOS</b-nav-item>
    </b-nav>

  
    <div id="loader">
      <!-- <img id="loaderImg" src="../assets/loader.gif" alt /> -->
      <div class="lds-ellipsis"><div class="bg-lgreen"></div><div class="bg-lgreen"></div><div class="bg-lgreen"></div><div class="bg-lgreen"></div></div>
    </div>
    <div id="no-campaigns" v-if="campaigns.length == 0">
      <p>Oooops... There aren't available offers at the moment. Please come back later</p>
    </div>

    <div>
    <!-- <b-button id="show-btn" @click="$bvModal.show('bv-modal-example')">Open Modal</b-button> -->
      <b-modal id="storeDetails" hide-footer>
          <template id="modal-Title" v-slot:modal-title>
              Guadagna <span id="modalCoins"></span> monete
          </template>
        <StoreDetail
        :url="selectedDetails.storeUrl"
        :title="selectedDetails.appName"
        :description="selectedDetails.description"
        :img="selectedDetails.img"
        :publisher="selectedDetails.publisher"
        :fastActions="selectedDetails.fastActions"
        :imageUrl="selectedDetails.image"
        :coins="selectedDetails.coins"></StoreDetail>
      </b-modal>
    </div>

    <!-- <div v-if="campaigns.length == 1 || campaigns.length > 1 && !firtsCover">
      <Card v-if="!isInstalled(campaigns[0].package) && campaigns[0].type === 'offer'"
      v-bind:key="campaigns.ID"
        @open-store="goToStore"
        :Title="campaigns[0].title"
        :FastActions="campaigns[0].fastActions"
        :Time="campaigns[0].time +' '+ $locale.cards.minutes"
        :Model="campaigns[0].model"
        :IconURL="campaigns[0].iconUrl"
        :Coins="parseInt(campaigns[0].coins * cval)"
        :Id="campaigns[0].id"
        :ApiKey="urlParams.apiKey"
        :Os="urlParams.os"
        :Country="urlParams.country"
        :Adv_id="campaigns[0].adv_id"
        :Cval="cval"
        :Lang="lang"
        :OptionalParams="optionalParams"
        :Ratio="ratio"
        :Metadata="campaigns[0].metadata"
        :Description="campaigns[0].description"
      ></Card>
      <PollCard v-else-if="campaigns[0].type === 'survey'"
        :title="campaign.sponsor.includes('Demographics') ? $locale.pollfish.profilation : $locale.pollfish.title+campaigns[0].sponsor"
        :sponsor="campaigns[0].sponsor"
        :url="campaigns[0].url"
        :coins="parseInt(campaigns[0].coins * cval)"
        :loi="campaigns[0].time +' '+ $locale.cards.minutes"
        :id="campaigns[0].id"
        :Cval="cval"
        :Lang="lang"
        :OptionalParams="optionalParams"
        :Ratio="ratio"
        :ApiKey="urlParams.apiKey"
        :Os="urlParams.os"
        :Country="urlParams.country"
        :Advertorial="'https://lh3.googleusercontent.com/1gn9t-s1AJbT0KA3zSvG9G83wM1Wa-8ReCmuBZBjMzwAyjtCj4XBCXq_JETTCoH_pb0=h500'"
        :IconUrl="'http://myapptree.org/wp-content/uploads/2020/01/LogoSmallerhdpi.png'"
      ></PollCard>
    </div> -->

    <div v-if="campaigns.length >= 1 && !isInstalled(campaigns[0].package) && !!firtsCover">
      <MainCard
      :class="{'superMainCard': !isMobile()}"
        v-if="campaigns[0].type == 'offer'"
        v-bind:key="campaigns[0].ID"
        @open-store="goToStore"
        :Title="campaigns[0].title"
        :Model="campaigns[0].model"
        :FastActions="campaigns[0].fastActions"
        :Time="campaigns[0].time +' '+ $locale.cards.minutes"
        :ImgURL="firtsCover"
        :Coins="parseInt(campaigns[0].coins * cval)"
        :Id="campaigns[0].id"
        :ApiKey="urlParams.apiKey"
        :Os="urlParams.os"
        :Country="urlParams.country"
        :Adv_id="campaigns[0].adv_id"
        :Cval="cval"
        :Lang="lang"
        :OptionalParams="optionalParams"
        :Ratio="ratio"
        :Metadata="campaigns[0].metadata"
        :Description="campaigns[0].description"
        :IconURL="campaigns[0].iconUrl"
      ></MainCard>
      <MainPollCard
          v-else-if="campaigns[0].type == 'survey' "
          @click.native="goToSurveyPage(campaigns[0].url)"
          :Title="campaign.sponsor.includes('Demographics') ? $locale.pollfish.profilation : $locale.pollfish.title+campaigns[0].sponsor"
          :sponsor="campaigns[0].sponsor"
          :url="campaigns[0].url"
          :Coins="parseInt(campaigns[0].coins * cval)"
          :loi="campaigns[0].time +' '+ $locale.cards.minutes"
          :Id="campaigns[0].id"
          :Cval="cval"
          :Lang="lang"
          :OptionalParams="optionalParams"
          :Ratio="ratio"
          :ApiKey="urlParams.apiKey"
          :Os="urlParams.os"
          :Country="urlParams.country"
          :Advertorial="'https://www.arenadigitale.it/wp-content/uploads/2019/11/survey.png'"
          :IconUrl="'http://myapptree.org/wp-content/uploads/2020/01/LogoSmallerhdpi.png'"
        ></MainPollCard>
    </div>
    <div id="cards">
      <div v-for="campaign in buttonCampaigns" v-bind:key="campaign.id">
        <ButtonCard
          :title="campaign.title"
          :url="campaign.url"
          :coins="parseInt(campaign.payout * cval)"
          :time="campaign.time +' '+ ((campaign.time > 1) ? $locale.cards.minutes : $locale.cards.minute)"
          :id="campaign.id"
          :type="campaign.type"
          :icon="campaign.icon"
        ></ButtonCard>
      </div>
      <div v-for="campaign in campaigns.slice(1,campaigns.length)" v-bind:key="campaign.ID">
        <Card
          v-if="!(isInstalled(campaign.package)) && campaign.type === 'offer' && isMobile()"
          @open-store="goToStore"
          :Title="campaign.title"
          :FastActions="campaign.fastActions"
          :Time="campaign.time +' '+ $locale.cards.minutes"
          :Model="campaign.model"
          :IconURL="campaign.iconUrl"
          :Coins="parseInt(campaign.coins * cval)"
          :Id="campaign.id"
          :ApiKey="urlParams.apiKey"
          :Os="urlParams.os"
          :Country="urlParams.country"
          :Adv_id="campaign.adv_id"
          :Cval="cval"
          :Lang="lang"
          :OptionalParams="optionalParams"
          :Ratio="ratio"
          :Metadata="campaign.metadata"
          :Description="campaign.description"
          :Advertorial="campaign.advertorial"
        ></Card>

        <MainCard
            v-else-if="!isMobile() && campaign.type == 'offer' "
            class="webCard"
            v-bind:key="campaign.ID"
            @open-store="goToStore"
            :Title="campaign.title"
            :Model="campaign.model"
            :FastActions="campaign.fastActions"
            :Time="campaign.time +' '+ $locale.cards.minutes"
            :Coins="parseInt(campaign.coins * cval)"
            :Id="campaign.id"
            :ApiKey="urlParams.apiKey"
            :Os="urlParams.os"
            :Country="urlParams.country"
            :Adv_id="campaign.adv_id"
            :Cval="cval"
            :Lang="lang"
            :OptionalParams="optionalParams"
            :Ratio="ratio"
            :Metadata="campaign.metadata"
            :Description="campaign.description"
            :ImgURL="setFirst(campaign)"
            :IconURL="campaign.iconUrl"
          ></MainCard>

          <MainPollCard
            v-else-if="!isMobile() && campaign.type == 'survey' "
            class="webCard"
            @click.native="goToSurveyPage(campaign.url)"
            :Title="campaign.sponsor.includes('Demographics') ? $locale.pollfish.profilation : $locale.pollfish.title+campaign.sponsor"
            :sponsor="campaign.sponsor"
            :url="campaign.url"
            :Coins="parseInt(campaign.coins * cval)"
            :loi="campaign.time +' '+ $locale.cards.minutes"
            :Id="campaign.id"
            :Cval="cval"
            :Lang="lang"
            :OptionalParams="optionalParams"
            :Ratio="ratio"
            :ApiKey="urlParams.apiKey"
            :Os="urlParams.os"
            :Country="urlParams.country"
            :Advertorial="'https://www.arenadigitale.it/wp-content/uploads/2019/11/survey.png'"
            :IconUrl="'http://myapptree.org/wp-content/uploads/2020/01/LogoSmallerhdpi.png'"
          ></MainPollCard>

        <PollCard 
          v-else-if="campaign.type === 'survey'"
          :title="campaign.sponsor.includes('Demographics') ? $locale.pollfish.profilation : $locale.pollfish.title+campaign.sponsor"
          :sponsor="campaign.sponsor"
          :url="campaign.url"
          :coins="parseInt(campaign.coins * cval)"
          :loi="campaign.time +' '+ $locale.cards.minutes"
          :id="campaign.id"
          :Cval="cval"
          :Lang="lang"
          :OptionalParams="optionalParams"
          :Ratio="ratio"
          :ApiKey="urlParams.apiKey"
          :Os="urlParams.os"
          :Country="urlParams.country"
          :Advertorial="'https://lh3.googleusercontent.com/1gn9t-s1AJbT0KA3zSvG9G83wM1Wa-8ReCmuBZBjMzwAyjtCj4XBCXq_JETTCoH_pb0=h500'"
          :IconUrl="'http://myapptree.org/wp-content/uploads/2020/01/LogoSmallerhdpi.png'"
        ></PollCard>
      </div>
    </div>
    <!-- <div v-for="poll in surveys" v-bind:key="poll.id">
      <PollCard
        :title="$locale.pollfish.title+poll.sponsor"
        :sponsor="poll.sponsor"
        :url="poll.url"
        :coins="poll.coins"
        :loi="poll.loi"
        :id="poll.id"
        :Cval="cval"
        :Lang="lang"
        :OptionalParams="optionalParams"
        :Ratio="ratio"
        :ApiKey="urlParams.apiKey"
        :Os="urlParams.os"
        :Country="urlParams.country"
        :Advertorial="'https://lh3.googleusercontent.com/1gn9t-s1AJbT0KA3zSvG9G83wM1Wa-8ReCmuBZBjMzwAyjtCj4XBCXq_JETTCoH_pb0=h500'"
        :IconUrl="'https://lh3.googleusercontent.com/pB5u5FjWnuG9w-lCgJiKKXGKttgnEl4r2q64yTqgFAbN8dxJ5vd4Y2TznJrZ58ip9A=h150-rw'"
      ></PollCard>
    </div> -->
    <div id="lastElement">
      <!-- <img id="lastElementImg" src="../assets/eloader.gif" /> -->
      <div id="lastElementImg" class="spinners">
        <div class="dot1 bg-lgreen"></div>
        <div class="dot2 bg-dgreen"></div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import { datas } from "../../variable.js";
import Card from "./Card.vue";
import MainCard from "./MainCard.vue";
import Navbar from "./Navbar.vue";
import PollCard from "./PollCard.vue";
import StoreDetail from "./StoreDetail.vue";
import MainPollCard from './MainPollCard';
import ButtonCard from './ButtonCard';
// import Tree from "./Tree.vue";
/* eslint-disable no-console*/

const utility = require('./utility.js')

export default {
  name: "home",
  data() {
    return {
      campaigns: [],
      surveys: [],
      lastResponse: [""],
      adv_id: "",
      firtsCover: "",
      lang: "",
      cval: "",
      clickId: "",
      totalCoins: "",
      dbURL: "",
      pollURL: "",
      ratio: 1,
      totalTrees: "",
      userTrees: "",
      urlParams: {
        apiKey: this.$route.params.apiKey,
        os: this.$route.params.OS,
        country: this.$route.params.country
      },
      optionalParams: [],
      userAgent: navigator.userAgent,
      allowSurveys: "",
      country:'',
      selectedDetails: {
        divideActions: "",
        storeUrl: "",
        appName : "",
        description : "",
        img : "",
        publisher : "",
        fastActions : "",
        image : "",
        coins : "",       
      },
      buttonCampaigns: []
      // posY: 0
    };
  },

  // beforeRouteLeave (to, from, next) {
  //   this.posY = window.scrollY;
  //   next()
  // },

  // activated () {
  //   /* eslint-disable no-console*/
  //   if(this){
  //     console.log("posy= "+this.posY)
  //     window.scrollY = this.posY;
  //   }else
  //   console.log("no this")
  // },
  // activated(){
  //   /* eslint-disable no-console*/
  //   console.log(this.$children[0])
  //   for(let i=0; i<this.$children.length; i++){
  //     console.log(i);
  //   }
  //   this.$children.forEach(component => {
  //     console.log(component);
  //   });
  // },
 watch: {
    $route() {
      if(this.$route.query.style !== "myAppTree" || !this.isMobile()){
        window.location.reload(); //cercare di ottimizzarla con le chiamate axios
      }
    }
  },
  created() {

    axios.get("https://us-central1-mychips-staging.cloudfunctions.net/getCountry").then(res=>{
        this.country = res.data
        this.urlParams.country
        if(this.$route.name == 'notOs'){
          console.log(1, this.getUserOs())  
          this.createPath(this.getUserOs(),res.data)  
        }else if(this.$route.name == 'Os') {
          console.log(2, this.$route.params.OS)  
          this.createPath(this.$route.params.OS,res.data)    
        }else if(this.$route.params.country != res.data){
          console.log(3, this.$route.params.OS)   
          this.createPath(this.$route.params.OS,res.data)
        }
    })
    
         
        console.log(this.country)

         window.showNotification = this.showNotification;
    window.isMobile = this.isMobile;
    window.goToStore = this.goToStore;
    window.getUserOs = this.getUserOs;
    if (
      !(this.$route.query.style == "myAppTree") &&
      this.$route.query.auto != 0
    )

    window.scrollTo(0, 0);
    console.log(this.getUserOs());
    console.log(this.isMobile());
    // console.log("uuid: "+localStorage.getItem("UUID"))

    if (this.$route.query.style == "myAppTree") {
      var uuid = localStorage.getItem("UUID");
      let token = (this.$route.query.token) ? this.$route.query.token : ""
      if (uuid == null) {
        var userID = this.generateUUID();
        localStorage.setItem("UUID", userID);

        axios.get(
          "https://us-central1-myapptree-20dac.cloudfunctions.net/createCounter/?userid=" +
            userID +
            "&token=" +
            token
        );
      }
    }

    if (this.$route.query.name) document.title = this.$route.query.name;
    if (this.$route.query.logo)
      document.getElementById("fav-icon").href = this.$route.query.logo;
    if (this.$route.query.totalCoins != null)
      this.totalCoins = this.$route.query.totalCoins;
    else this.totalCoins = 0;
    this.adv_id = this.$route.query.advertising_id;
    if (this.$route.query.cval) this.cval = this.$route.query.cval;
    else this.cval = 1;
    if (this.$route.query.lang) this.lang = this.$route.query.lang;
    else if (this.urlParams.country) this.lang = this.urlParams.country.toLowerCase();
    else this.lang = "";
    if(this.$route.query.uid) this.clickId = this.$route.query.uid;
    else if(this.$route.query.click_id) this.clickId = this.$route.query.click_id;
    else this.clickId = ""; 

    this.dbURL =
      "https://us-central1-mychips-b31fe.cloudfunctions.net/readTenOffers/?OS=" +
      // this.urlParams.os +
      this.$route.params.OS +
      "&country=" +
      this.urlParams.country +
      "&apiKey=" +
      this.urlParams.apiKey;
    console.log(this.dbURL)
    var osEnum = 3;

    switch (this.urlParams.os){
      case "ANDROID": osEnum = 0; break;
      case "IOS": osEnum = 1; break;
      default: osEnum = 3;
    }

    // console.log("dburl ", this.dbURL)

    var token = (this.$route.query.token) ? this.$route.query.token : 0

    this.pollURL = "https://wss.pollfish.com/v2/device/register/true?dontencrypt=true&json=%7B%22offerwall%22%3A%22true%22%2C%22api_key%22%3A%222fde8acc-f856-487f-a9ed-eb89f76f94e7%22%2C%22device_id%22%3A%22"+
    localStorage.getItem("UUID")+ //quando in debug il device ID deve essere AA, AB o UNKNOW_DEVICE_ID
    //"UNKNOWN_DEVICE_ID"+
    "%22%2C%22request_uuid%22%3A%22"+
    //notification token
    token+
    "%22%2C%22timestamp%22%3A"+
    //timestamp
    Date.now()+
    "%2C%22debug%22%3A"+
    //debug mode
    "false"+
    "%2C%22ip%22%3A%2272.229.28.185%22%2C%22encryption%22%3A%22NONE%22%2C%22version%22%3A7%2C%22os%22%3A"+
    //os: android = 0, ios = 1, web = 3
    osEnum+
    "%2C%22locale%22%3A%22"+
    //lang
    ((this.lang == "it") ? "it" : "en")+
    "%22%2C%22always_return_content%22%3Afalse%2C%22content_type%22%3A%22json%22%7D"

    // console.log(this.pollURL);

      // console.log(this.dbURL)
      
    if (this.$route.query.surveys && this.$route.query.surveys === "1") {
      this.allowSurveys = true;
    } else if (this.$route.query.surveys && this.$route.query.surveys === "0") {
      this.allowSurveys = false;
    } else {
      axios.get(
        "https://us-central1-mychips-staging.cloudfunctions.net/areSurveysActive?publisher=" + this.urlParams.apiKey
      )
      .then(async response => {
        if (response.data){
          this.allowSurveys = true;
        }
      })
    }
    while (datas.length > 0) datas.pop();

    axios.get(this.dbURL).then(response => {
      document.getElementById("loader").style.display = "none";
      if (response.data.length === 0)
        document.getElementById("no-campaigns").style.display = "block";
      response.data.forEach(el => {
        // if (el.Payout < 1) el.Payout = 1;
        datas.push(el);

        var camp = new utility.Campaign(el);

        this.campaigns.push(camp);

        this.campaigns.sort((a, b) => {
          if(a.time == b.time){
            return b.coins - a.coins;
          }else{
            return a.time - b.time;
          }
          
          // return b.coins - a.coins;
        });
      });
      if(this.campaigns[0] && this.campaigns[0].creatives)
        this.firtsCover = this.setCover(this.campaigns[0].creatives);
      // console.log(this.campaigns);
    });

//fixare: se !myapptree fare solo se this.allowSurveys
    if(this.$route.query.style == 'myAppTree'){
      axios.get(this.pollURL).then(response => {

        if(response.data)
        response.data.surveys.forEach(poll =>{

          var surv = new utility.Poll(poll);
        /* if(surv.sponsor.includes("ThirdParty"))
            this.campaigns.splice(this.campaigns.length, 0, surv);
          else*/
            this.campaigns.push(surv);
          // this.campaigns.sort((a, b) => { //scommentare
          //   return b.coins - a.coins;
          // });

          // this.surveys.push(surv);

          // this.surveys.sort((a, b) => {
          //   return b.coins - a.coins;
          // });
        });
        // this.surveys.forEach(poll => {
        //   this.campaigns.push(poll);
        // })
        console.log(this.surveys)
      });
    }

    if(this.$route.query.style == "myAppTree"){
      if(!localStorage.mailNeverAgain){
        var newsletterCampaign = {
          title: this.$locale.newsletter.cardtitle,
          type: "modal",
          payout: 0.1,
          id: "newsletter",
          time: 1,
          url: "newsletterformmodal",
          icon: "@/assets/mail-icon.svg"
        }
        this.buttonCampaigns.push(newsletterCampaign)
      }
    }

    this.getAllQueryParams();
    //this.bottom();

  },
  mounted() {
      
     if(!this.isMobile()) {
      console.log('!mobile')
      document.getElementById("app").style.marginLeft = "23vw";
      document.getElementById("app").style.marginRight = "23vw";
    
    var currentTab = document.getElementsByClassName(this.$route.params.OS);
    currentTab[0].style.backgroundColor = '#2861a7';
    currentTab[0].style.color = 'white';
    currentTab[0].style.borderRadius = '50px';
    currentTab[0].style.borderBottom = '1.5px solid #2861a7'
    }   
  },

  components: {
    Card,
    MainCard,
    Navbar,
    PollCard,
    MainPollCard,
    StoreDetail,
    ButtonCard,
  },
  methods: {
        goToSurveyPage: function(url){
      console.log('iframe')
      window.pollLink = url;
      // this.$bvModal.show('pollModal');
      window.open(url);
    },
    showNotification: function(title,options){
      
      if (this.$route.query.notification === "1") {
        new Notification(title, options);
      } else if (!this.isMobile() && this.$route.query.notification !== "0") {
        new Notification(title, options);
      }
    },
    setFirst: function(campaign) {
      if (campaign.creatives.length > 0) {
        return campaign.creatives[0].Url;
      }else{
        if(this.$route.query.style == 'myAppTree'){
          return "https://lh3.googleusercontent.com/pB5u5FjWnuG9w-lCgJiKKXGKttgnEl4r2q64yTqgFAbN8dxJ5vd4Y2TznJrZ58ip9A=s360-rw"
        }else if(this.$route.query.logo){
          return this.$route.query.logo
        }else{
          return "https://cdn.hipwallpaper.com/i/97/93/HYSI5B.jpg"
        }
      }
        // return "data:image/png;base64,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";
    },

    createPath: function(os,country) {
      this.$router.push({ name: 'Home', query:this.$route.query , params:{OS: os, country: country}});
    },

    isMobile: function() {
      if (
        /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
          this.userAgent
        )
      ) {
        return true;
      } else {
        // document.getElementById("app").style.marginLeft = "20%";
        // document.getElementById("app").style.marginRight = "20%";
        return false;
      }
    },

    getUserOs: function() {
      var userAgent = navigator.userAgent || navigator.vendor || window.opera;
      console.log(userAgent);

      // Windows Phone must come first because its UA also contains "Android"
      if (/windows phone/i.test(userAgent)) {
        return "WINDOWS PHONE";
      }

      if (/android/i.test(userAgent)) {
        return "ANDROID";
      }

      // iOS detection from: http://stackoverflow.com/a/9039885/177710
      if (/iPad|iPhone|iPod/.test(userAgent) && !window.MSStream) {
        return "IOS";
      }

      return "WEB";
    },

    isInstalled: function(pacchetto) {
      if (window.Android && this.$route.query.style == 'myAppTree') {
        return window.Android.isPackageInstalled(pacchetto);
      } else return false;
    },
    // async counters() {
    //   var uuid = localStorage.getItem("UUID");

    //   if (window.Android && this.$route.query.style == 'myAppTree') {
    //     await axios
    //       .get(
    //         "https://us-central1-myapptree-20dac.cloudfunctions.net/getNumberOfTrees"
    //       )
    //       .then(res => {
    //         this.lTrees = res.data.Counter;
    //       });

    //     await axios
    //       .get(
    //         "https://us-central1-myapptree-20dac.cloudfunctions.net/getNumberOfTrees?userid=" +
    //           uuid
    //       )
    //       .then(res => {
    //         this.userTrees = res.data.Counter;
    //       });

    //     window.Android.totalTrees(this.totalTrees);
    //     window.Android.userTrees(this.userTrees);
    //   }
    // },
    generateUUID: function() {
      return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, function(
        c
      ) {
        var r = (Math.random() * 16) | 0,
          v = c == "x" ? r : (r & 0x3) | 0x8;
        return v.toString(16);
      });
    },
    /*
    bottom: function() {
      // window.onscroll = () => {
        // window.ontouchmove = () => {  //it doesn't need body to have height:100% or overflow
        document.querySelector('#home').ontouchmove = () => {  //it doesn't need body to have height:100% or overflow

        var elem = document.querySelector("#lastElement");
        var bounding = elem.getBoundingClientRect();
        if (
          bounding.top >= 0 &&
          bounding.left >= 0 &&
          bounding.bottom <=
            (window.innerHeight + 0.5 ||
              document.documentElement.clientHeight + 0.5) &&
          this.lastResponse.length > 0
        ) {
          console.log("bottom")
          if (this.campaigns.length > 9) {
            document.getElementById("lastElementImg").style.display = "block";
            this.updateData();
          }
        }
      };
    }, */
    scrolling: function(){
      console.log("scrolling");
      var elem = document.querySelector("#lastElement");
      var bounding = elem.getBoundingClientRect();
      if (
        bounding.top >= 0 &&
        bounding.left >= 0 &&
        bounding.bottom <=
          (window.innerHeight + 0.5 ||
            document.documentElement.clientHeight + 0.5) &&
        this.lastResponse.length > 0
      ) {
        // console.log("last respose", this.lastResponse.length)
        console.log("bottom")
        if (this.campaigns.length > 9) {
          document.getElementById("lastElementImg").style.display = "block";
          this.updateData();
        }
      }
  },
    updateData: function() {
      console.log("update");
      // let index = this.campaigns.length - 1;
      // var lastId = this.campaigns[index].id;
      
      // //find id of the last "offer" campaign to ask for more to db
      // while(this.campaigns[index].type !== 'offer' && index >= 0){
      //   console.log(this.campaigns[index].type, index)
      //   index--;
      //   // if (this.campaigns[index].type === 'offer')
      //   //   lastId = this.campaigns[index].id
      // }
      // lastId = this.campaigns[index].id;
      // console.log("last", this.campaigns[index].type,this.campaigns[index].title, this.campaigns[index].id, index)
      console.log(datas)
      var lastId = datas[datas.length - 1].ID;
      console.log(lastId)

      this.dbURL =
        "https://us-central1-mychips-b31fe.cloudfunctions.net/readTenOffers?campaignId=" +
        lastId +
        "&OS=" +
        this.urlParams.os +
        "&country=" +
        this.urlParams.country +
        "&apiKey=" +
        this.urlParams.apiKey;
      console.log(this.dbURL)

      while (this.lastResponse.length > 0) this.lastResponse.pop();
      axios.get(this.dbURL).then(response => {
        // document.getElementById("lastElementImg").style.padding = "0px";
        document.getElementById("lastElementImg").style.display = "none";
        console.log("while", response);
        response.data.forEach(el => {
          // if (el.Payout < 1)
          //   el.Payout = 1;
          datas.push(el);
          // el.sort((a, b) => {
          //   return b.coins - a.coins;
          // });
          var camp = new utility.Campaign(el);
          this.campaigns.push(camp);
          console.log("new campaigns", camp);
          // const data = {
          //   title: el.Title,
          //   fastActions: this.checkFastActions(el),
          //   time: this.countUserFlow(el.UserFlow) + " minutes",
          //   coins: el.Payout,
          //   iconUrl: el.Icon,
          //   id: el.ID,
          //   language: el.Language,
          //   creatives: el.Creatives,
          //   adv_id: el.TrackingUrl,
          //   model: el.Model,
          //   package: el.Package
          // };
          // this.campaigns.push(data);
          // this.lastResponse.push(data);
        });
      });
    },
    getAllQueryParams: function() {
      const urlParameters = window.location.href;
      if (urlParameters.includes("?")) {
        var qString = urlParameters.split("?");
        var params = qString[1].split("&");
        params.forEach(el => {
          this.optionalParams.push(el);
        });
      }
    },
    countUserFlow: function(actions) {
      var actionsList = [];
      actionsList = actions.split("|");
      var time = 0;
      actionsList.forEach(el => {
        if (el.includes("Install")) time += 3;
        else if (el.includes("Open")) time += 2;
        else if (el.includes("level")) time += 10;
        else time += 5;
      });
      if (actionsList[0] == "") time = 5;
      return time;
    },
    checkFastActions: function(element) {
      var flows = "";
      if (element.UserFlow == "") {
        flows = "Install|Open";
        datas.forEach(el => {
          if (el.ID == element.ID) el.UserFlow = flows;
        });
      } else flows = element.UserFlow;
      return flows;
    },

    setCover: function(creatives) {
      var url = "";
      Object.keys(creatives).forEach(el => {
        if (creatives[el].Type == "ADVERTORIAL_COVER") {
          url = creatives[el].Url;
        }
      });
      if (url != "") return url;
      else {
        if(creatives[Object.keys(creatives)[0]])
          return creatives[Object.keys(creatives)[0]].Url
        else
          return null
      }
    },
    async goToStore(storeUrl,Title,Description,Img,Publisher,FastActions,Image,Coins) {
      if (this.isMobile()) {
        console.log("init url ",storeUrl);
        if ((window.Android || window.webkit) && this.$route.query.style == 'myAppTree') {
          // var uuid = localStorage.getItem("UUID");
          // var totalTrees;
          // var userTrees;
          //splittato perchè il limite è 150 caratteri
          var token = this.$route.query.token;
          var token1 = token.substring(0, token.length / 2);
          var token2 = token.substring(token.length / 2, token.length);

          // await axios
          //   .get(
          //     "https://cors-anywhere.herokuapp.com/https://us-central1-myapptree-20dac.cloudfunctions.net/getNumberOfTrees"
          //   )
          //   .then(res => {
          //     totalTrees = res.data.Counter;
          //     /* eslint-disable no-console */
          //     console.log(totalTrees);
          //     /* eslint-enable no-console */
          //   });

          // await axios
          //   .get(
          //     "https://cors-anywhere.herokuapp.com/https://us-central1-myapptree-20dac.cloudfunctions.net/getNumberOfTrees?userid=" +
          //       uuid
          //   )
          //   .then(res => {
          //     userTrees = res.data.Counter;
          //     /* eslint-disable no-console */
          //     console.log(userTrees);

          //   });

          storeUrl =
            storeUrl +
            this.gaid() +
            this.addTrackingParams() +
            "&aff_sub1=" +
            localStorage.getItem("UUID") +
            "&aff_sub2=" +
            this.urlParams.country +
            "&aff_sub3=" +
            token1 +
            "&aff_sub4=" +
            token2;

          if (window.Android){
            window.Android.goToPlayStore(storeUrl);
            window.Android.SendEvent('View', '{"name": "Open Url", "uri": "'+storeUrl+'"}')
          }else if (window.webkit){
            window.webkit.messageHandlers.iOS.postMessage({action: "openUrl", param2: storeUrl});
            window.webkit.messageHandlers.iOS.postMessage({action: "sendEvent", param2: "View", param3: "Open Url"});
          }

        } else {  //else -> it's MYCHIPS mobile
          // console.log("gotostore start");
          storeUrl =
            storeUrl +
            this.gaid() +
            this.addTrackingParams() +
            "&aff_sub1=" +
            localStorage.getItem("UUID") +
            "&aff_sub2=1" +
            "&aff_sub5=" +
            this.clickId +
            "&click_id="+
            this.generateUUID()

          console.log("final url", storeUrl);

          window.location.href = storeUrl;
          //this.$cookie.set(this.id, "1");
          // console.log('end');
        }
      }else{
        if(this.$route.params.OS != 'WEB'){ //if MYCHIPS ANDROID or IOS tabs
            this.$bvModal.show('storeDetails');
            document.body.style.width = '100%!important';
            this.selectedDetails.storeUrl = 
            storeUrl +
            this.gaid() +
            this.addTrackingParams() +
            "&aff_sub1=" +
            localStorage.getItem("UUID") +
            "&aff_sub2=" +
            this.urlParams.country +
            "&aff_sub3=" +
            token1 +
            "&aff_sub4=" +
            token2 +
            "&aff_sub5=" +
            this.clickId +
            "&click_id="+
            this.generateUUID();

            this.selectedDetails.appName = Title;
            this.selectedDetails.description = Description;
            this.selectedDetails.img = Img;
            this.selectedDetails.publisher = Publisher;
            this.selectedDetails.fastActions = FastActions;
            this.selectedDetails.image = Image;
            this.selectedDetails.coins = Coins;
          }else{ //else -> MYCHIPS WEB
            storeUrl = 
                storeUrl +
                this.gaid() +
                this.addTrackingParams() +
                "&aff_sub1=" +
                localStorage.getItem("UUID") +
                "&aff_sub2=" +
                this.urlParams.country +
                "&aff_sub3=" +
                token1 +
                "&aff_sub4=" +
                token2 +
                "&aff_sub5=" +
                this.clickId +
                "&click_id="+
                this.generateUUID();
                // console.log(storeUrl)
                window.open(storeUrl);
          }
        }       
      },
     addTrackingParams: function() {
      const urlParameters = window.location.href;
      var trackingParams = "";
      if (urlParameters.includes("?")) {
        var qString = urlParameters.split("?");
        var params = qString[1].split("&");

        params.forEach(el => {
          if (
            !el.includes("name") &&
            !el.includes("totalCoins") &&
            !el.includes("logo") &&
            !el.includes("cval") &&
            !el.includes("advertising_id") &&
            !el.includes("lang")
          ) {
            trackingParams = trackingParams + "&" + el;
          }
        });
      }
      return trackingParams;
    },
     gaid: function() {
      var tUrl = "";
      if (this.urlParams.os == "ANDROID")
        tUrl = tUrl + "&gaid=" + (this.$route.query.advertising_id ? this.$route.query.advertising_id : "");
      else if (this.urlParams.os == "IOS")
        tUrl = tUrl + "&ios_idfa=" + (this.$route.query.advertising_id ? this.$route.query.advertising_id : "");
      return tUrl;
    },
  }
};
</script>
<style scoped>
  .lds-ellipsis {
  display: inline-block;
  position: relative;
  width: 80px;
  height: 80px;
}
.lds-ellipsis div {
  position: absolute;
  top: 33px;
  width: 13px;
  height: 13px;
  border-radius: 50%;
  /* background: #fff; */
  animation-timing-function: cubic-bezier(0, 1, 1, 0);
}
.lds-ellipsis div:nth-child(1) {
  left: 8px;
  animation: lds-ellipsis1 0.6s infinite;
}
.lds-ellipsis div:nth-child(2) {
  left: 8px;
  animation: lds-ellipsis2 0.6s infinite;
}
.lds-ellipsis div:nth-child(3) {
  left: 32px;
  animation: lds-ellipsis2 0.6s infinite;
}
.lds-ellipsis div:nth-child(4) {
  left: 56px;
  animation: lds-ellipsis3 0.6s infinite;
}
@keyframes lds-ellipsis1 {
  0% {
    transform: scale(0);
  }
  100% {
    transform: scale(1);
  }
}
@keyframes lds-ellipsis3 {
  0% {
    transform: scale(1);
  }
  100% {
    transform: scale(0);
  }
}
@keyframes lds-ellipsis2 {
  0% {
    transform: translate(0, 0);
  }
  100% {
    transform: translate(24px, 0);
  }
}

.spinners {
  margin: 3rem auto;
  width: 40px;
  height: 40px;
  position: relative;
  text-align: center;

  -webkit-animation: sk-rotate 2.0s infinite linear;
  animation: sk-rotate 2.0s infinite linear;
}

.dot1, .dot2 {
  width: 60%;
  height: 60%;
  /* display: inline-block; */
  position: absolute;
  top: 0;
  /* background-color: #333; */
  border-radius: 100%;

  -webkit-animation: sk-bounce 2.0s infinite ease-in-out;
  animation: sk-bounce 2.0s infinite ease-in-out;
}

.dot2 {
  top: auto;
  bottom: 0;
  -webkit-animation-delay: -1.0s;
  animation-delay: -1.0s;
}

@-webkit-keyframes sk-rotate { 100% { -webkit-transform: rotate(360deg) }}
@keyframes sk-rotate { 100% { transform: rotate(360deg); -webkit-transform: rotate(360deg) }}

@-webkit-keyframes sk-bounce {
  0%, 100% { -webkit-transform: scale(0.0) }
  50% { -webkit-transform: scale(1.0) }
}

@keyframes sk-bounce {
  0%, 100% {
    transform: scale(0.0);
    -webkit-transform: scale(0.0);
  } 50% {
    transform: scale(1.0);
    -webkit-transform: scale(1.0);
  }
}
</style>
